
<template>
    <div class="right_box_main">
        <div class="listBox-item">
            <!-- <div class="mianbao">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/griddingindex' }">网格工作</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/twoNetworkConvergence' }">两网融合</el-breadcrumb-item>
                    <el-breadcrumb-item>考勤时间管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->
            <el-card class="publicCard">
                <div class="fisthang">
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                        size="mini"
                    >
                        <el-form-item label="用户姓名">
                            <el-input
                                v-model="searchlist.userName"
                                placeholder="用户姓名"
                                style="width:120px;"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdata">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="listBox-item">
                    <el-button
                        class="mb16"
                        type="primary"
                        size="mini"
                        @click="showDialog('','add')"
                    >新增</el-button>
                    <!-- 表格盒子 -->
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column align="center" prop="userName" label="用户名" :show-overflow-tooltip="true"></el-table-column>
                            <!-- <el-table-column align="center" prop="createPersonName" label="手机号"></el-table-column> -->
                            <el-table-column align="center" prop="orgName" label="组织机构" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="morningSignInTime" label="上午签到时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="morningSignOffTime" label="上午签退时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="afternoonSignInTime" label="下午签到时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="afternoonSignOffTime" label="下午签退时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="attendanceLocation" label="考勤地点" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="attendanceRange" label="考勤范围" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="createDate" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="删除"
                                        placement="top-start"
                                    >
                                        <button
                                            class="tabBtn el-icon-delete tabBtn-delete"
                                            @click="showDialog(scope.row,'delete')"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="查看"
                                        placement="top-start"
                                    >
                                        <button
                                            class="iconfont icon-chakan tabBtn"
                                            @click="look(scope.row)"
                                        ></button>
                                    </el-tooltip>
                                    <!-- <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="修改"
                                        placement="top-start"
                                    >
                                        <button
                                            @click="showDialog(scope.row,'update')"
                                            class="tabBtn el-icon-edit-outline tabBtn-edit"
                                        ></button>
                                    </el-tooltip>-->
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                    </div>

                    <!-- 新增界面 -->
                    <el-dialog :title="add.title" :visible.sync="add.off" width="700px">
                        <el-form
                            :rules="ruleArr"
                            ref="baseForm"
                            :model="add.form"
                            :before-close='offon'
                            label-width="120px"
                        >
                           <el-form-item label="所属网格：" prop="orgId">
                                <orgListSelect
                                    v-model="add.form.orgId"
                                    orgType="1"
                                    :on-success="onSuccess"
                                    style="width:100%"
                                />
                            </el-form-item>
                            <el-form-item label="人员姓名：" prop="personId">
                                <el-select
                                    v-model="add.form.personId"
                                    placeholder="请选择人员"
                                    ref="personName"
                                    multiple
                                    style="width:100%"
                                >
                                    <el-option
                                        v-for="item in userOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="执行时间：" prop="personId">
                                <el-date-picker
                                    style="width:100%"
                                    v-model="add.form.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-form-item>-->
                            <!-- 新增上午签到时间 -->
                            <el-form-item label="上午签到时间:" prop="morningSignInTime">
                                <el-time-select
                                    style="width:100%"
                                    v-model="add.form.morningSignInTime"
                                    :picker-options="{
                                            start: '08:30',
                                            step: '01:10',
                                            end: '12:00'
                                        }"
                                    placeholder="选择时间"
                                ></el-time-select>
                            </el-form-item>
                            <!-- 新增上午签退时间 -->
                            <el-form-item label="上午签退时间:" prop="morningSignOffTime">
                                <el-time-select
                                    style="width:100%"
                                    v-model="add.form.morningSignOffTime"
                                    :picker-options="{
                                            start: '08:30',
                                            step: '01:10',
                                            end: '12:00',
                                            minTime: add.form.morningSignInTime
                                        }"
                                    placeholder="选择时间"
                                ></el-time-select>
                            </el-form-item>
                            <!-- 新增下午签到时间-->
                            <el-form-item label="下午签到时间:" prop="afternoonSignInTime">
                                <el-time-select
                                    style="width:100%"
                                    v-model="add.form.afternoonSignInTime"
                                    :picker-options="{
                                            start: '14:30',
                                            step: '01:00',
                                            end: '17:30',
                                        }"
                                    placeholder="选择时间"
                                ></el-time-select>
                            </el-form-item>
                            <!-- 新增下午签到时间 -->
                            <el-form-item label="下午签退时间:" prop="afternoonSignOffTime">
                                <el-time-select
                                    style="width:100%"
                                    v-model="add.form.afternoonSignOffTime"
                                    :picker-options="{
                                            start: '14:30',
                                            step: '01:00',
                                            end: '17:30',
                                            minTime: add.form.afternoonSignInTime
                                        }"
                                    placeholder="选择时间"
                                ></el-time-select>
                            </el-form-item>

                            <el-form-item label="考勤范围：" prop="attendanceRange">
                                <el-select
                                    style="width:100%"
                                    v-model="add.form.attendanceRange"
                                    placeholder="请选择考勤范围"
                                    ref="personName"
                                    @change="changedata"
                                >
                                    <el-option label="10米" value="10"></el-option>
                                    <el-option label="50米" value="50"></el-option>
                                    <el-option label="100米" value="100"></el-option>
                                    <el-option label="200米" value="200"></el-option>
                                    <el-option label="300米" value="300"></el-option>
                                    <el-option label="400米" value="400"></el-option>
                                    <el-option label="500米" value="500"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="网格办事处：" prop="gridOfficeName">
                                <el-input :disabled="true" v-model="map.name"></el-input>
                            </el-form-item>
                            <el-form-item label="网格办事处：" prop="gridOfficeCordinate">
                                <mapLoca
                                    v-if="mapOff"
                                    :val="map.p"
                                    :center='center'
                                    style="width:100%;height:500px"
                                    :disabled="true"
                                ></mapLoca>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">{{add.title}}</el-button>
                            </el-form-item>
                        </el-form>
                    </el-dialog>



                    <el-dialog :title="add.title" :visible.sync="lookisshow" width="700px">
                        <el-form
                            :rules="ruleArr"
                            ref="baseForm"
                            :model="add.form"
                            :before-close='offon'
                            label-width="120px"
                        >
                            <el-form-item label="所属网格：" prop="orgId">
                                <el-input
                                v-model="add.form.orgName"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="人员姓名：" prop="personId">
                                <el-input
                                v-model="add.form.userName"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <!-- 新增上午签到时间 -->
                            <el-form-item label="上午签到时间:" prop="morningSignInTime">
                                <el-input
                                v-model="add.form.morningSignInTime"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <!-- 新增上午签退时间 -->
                            <el-form-item label="上午签退时间:" prop="morningSignOffTime">
                                <el-input
                                v-model="add.form.morningSignOffTime"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <!-- 新增下午签到时间-->
                            <el-form-item label="下午签到时间:" prop="afternoonSignInTime">
                                <el-input
                                v-model="add.form.afternoonSignInTime"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <!-- 新增下午签到时间 -->
                            <el-form-item label="下午签退时间:" prop="afternoonSignOffTime">
                                <el-input
                                v-model="add.form.afternoonSignOffTime"
                                :disabled="true">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="考勤范围：" prop="attendanceRange">
                                <el-input
                                v-model="add.form.attendanceRange"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="网格办事处：" prop="attendanceLocation">
                                <el-input
                                v-model="add.form.attendanceLocation"
                                :disabled="true">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="网格办事处：" prop="gridOfficeCordinate">
                                <mapLoca
                                    :val="add.form.officeCordinate"
                                    :center='add.form.attendanceRange'
                                    style="width:100%;height:500px"
                                    :disabled="true"
                                ></mapLoca>
                            </el-form-item>
                        </el-form>
                    </el-dialog>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
import { tabdata } from "@/mixins/tabledataMix.js";
import { validatePhoneOrMobile } from "@/utils/validate.js";
import orgListSelect from "@/component/orgListSelect/index.vue";
import mapLoca from "@/views/system/organization/mapLoca.vue";
export default {
    mixins: [tabdata],
    components: { orgListSelect, mapLoca },
    data() {
        return {
            mapOff: true,
            lookisshow:false, //查看弹窗
            map: {
                name: "",
                p: ""
            },
            center:0,
            ruleArr: {
                issueType: [
                    {
                        required: true,
                        message: "请输入纠纷类型名称",
                        trigger: "blur"
                    }
                ]
            },
            add: {
                form: {
                    orgId: [],
                    morningSignInTime: "",
                    morningSignOffTime: "",
                    afternoonSignInTime: "",
                    afternoonSignOffTime: ""
                },
                off: false
            },
            type: "",
            userOptions: [],
            tableData: []
        };
    },
    methods: {
        onSubmit() {
            this.$refs.baseForm.validate(valid => {
                if (valid) {
                    if (this.type == "add") {
                        // console.log(this.add.form.orgId[this.add.form.orgId.lenght - 1])
                        post("/admin/attendanceManager/info/insert", {
                            ...this.add.form,
                            personIds: this.add.form.personId,
                            orgId: this.add.form.orgId[
                                this.add.form.orgId.length - 1
                            ],
                            personId: "",
                            streetId: Number(this.add.form.orgId[0]),
                            communityId:
                                this.add.form.orgId.length >= 2
                                    ? Number(this.add.form.orgId[1])
                                    : "",
                            gridId:
                                this.add.form.orgId.length >= 3
                                    ? Number(this.add.form.orgId[2])
                                    : ""
                        }).then(res => {
                            this.add.off = false;
                            this.$message.success("新增成功");
                            this.getPageDatas();
                        });
                    } else {
                        post("/admin/issueType/info/update", {
                            ...this.add.form,
                            orgId: "",
                            personId: ""
                        }).then(res => {
                            this.add.off = false;
                            this.$message.success("修改成功");
                            this.getPageDatas();
                        });
                    }
                } else {
                    //   console.log("error submit!!");
                    return false;
                }
            });
        },
        changedata(data){
            this.center = data
        },
        //查看
        look:function(data){
            this.lookisshow = true
            this.add.title = "修改";
            this.add.form = JSON.parse(JSON.stringify(data));
        },
        showDialog(row, type) {
            this.type = type;
            switch (type) {
                case "add":
                    this.add.off = true;
                    this.add.title = "新增";
                    this.add.form = {
                        orgId: []
                    };
                    break;
                case "delete":
                    this.$confirm("此操作将删除该考勤, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        post("/admin/attendanceManager/info/delete", {
                            userId: row.userId,
                            id:row.id
                        }).then(res => {
                            this.$message({
                                type: "success",
                                message: "删除成功"
                            });
                            this.getPageDatas();
                        });
                    });
                    break;
                case "update":
                    this.add.off = true;
                    this.add.title = "修改";
                    this.add.form = JSON.parse(JSON.stringify(row));
                    break;
            }
        },
        onSuccess(info) {
            this.getUser(info.value);
            this.getMap(info.value);
        },
        //获取人员
        getUser(id) {
            this.userOptions = [];
            post("/admin/user/info/list", {
                orgId: id,
                pageNo: 1,
                pageSize: 99
            }).then(res => {
                res.content.list.forEach(e => {
                    this.userOptions.push({
                        value: e.id,
                        label: e.name
                    });
                });
            });
        },
        //获取坐标信息
        getMap(id) {
            post("/admin/org/info/findOrgById", {
                id
            }).then(res => {
                this.map.name = res.content.gridOfficeName;
                this.map.p = res.content.gridOfficeCordinate;
            });
        }
        // 获取考勤管理列表
        // async showUserList() {
        //     const { data: res } = await this.$http.post(
        //         "/admin/attendanceManager/info/list",
        //         {
        //             pageNo: 1,
        //             pageSize: 10
        //         }
        //     );
        //     if (res.meta.status !== 201) {
        //         return this.$message.error("获取数据失败");
        //     }
        //     this.$message.success("获取数据成功");
        //     this.tableData = res.data;
        // }
    },
    created() {
        // this.showUserList();
    },
    mounted() {
        // this.initTableDataUrl("/admin/attendanceManager/info/list");
    }
};
</script>

<style lang="less" scoped>
</style>
